/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <a href="{{du}}" aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <div class="swym-wishlist-image-wrapper media-wrapper" style="--aspect-ratio: 1">
       <img alt="" class="swym-wishlist-image motion-reduce" src="{{iu}}">
       <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
         <span class="swym-icon">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="dynamic-fill">
             <path d="M16.1111 3C19.6333 3 22 6.3525 22 9.48C22 15.8138 12.1778 21 12 21C11.8222 21 2 15.8138 2 9.48C2 6.3525 4.36667 3 7.88889 3C9.91111 3 11.2333 4.02375 12 4.92375C12.7667 4.02375 14.0889 3 16.1111 3Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="black"/>
           </svg>
         </span>
       </button>
     </div>
     <div class="swym-product-info">
       <h3 class="swym-title swym-title-1">
         {{dt}}
       </h3>
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
         {{variantinfo}}
       </div>
       <div class="product-card__price-row swym-product-price-row">
         <div class="f-price {{price_state_class}}">
           <div class="f-price__regular">
             <span class="f-price-item f-price-item--regular">{{formatted_price}}</span>
           </div>
           <div class="f-price__sale">
             <span class="f-price-item f-price-item--sale">{{formatted_price}}</span>
             <span class="f-price-item f-price-item--regular">
               <s class="price_sale_regular">{{formatted_compare_at}}</s>
             </span>
           </div>
         </div>
         <span class="product-card__cart-discount-badge {{cart_discount_hidden_class}}" aria-label="{{cart_discount_badge}}">{{cart_discount_badge_text}}</span>
       </div>
     </div>
   </a>
   {{/products}} 
</div>`;

// Store all products
let allProducts = [];

const CART_DISCOUNT_TIER_50_CENTS = 90000;
const CART_DISCOUNT_TIER_100_CENTS = 150000;
const CART_DISCOUNT_TIER_200_CENTS = 250000;
const CART_DISCOUNT_TIER_300_CENTS = 400000;

function getVariantInfo(variants) {
  if (variants.indexOf("/") > -1) {
    return variants;
  } else {
    return "";
  }
}

function formatWishlistMoney(cents) {
  const amount = Number(cents) || 0;
  if (window.FoxTheme?.Currency?.formatMoney) {
    return FoxTheme.Currency.formatMoney(
      amount,
      FoxTheme.settings?.moneyFormat || window.theme?.moneyFormat
    );
  }
  if (typeof Shopify?.formatMoney === "function") {
    return Shopify.formatMoney(amount);
  }
  return `$${(amount / 100).toFixed(2)}`;
}

function getCartDiscountBadge(priceCents) {
  if (priceCents >= CART_DISCOUNT_TIER_300_CENTS) return "+ extra $300 OFF at checkout";
  if (priceCents >= CART_DISCOUNT_TIER_200_CENTS) return "+ extra $200 OFF at checkout";
  if (priceCents >= CART_DISCOUNT_TIER_100_CENTS) return "+ extra $100 OFF at checkout";
  if (priceCents >= CART_DISCOUNT_TIER_50_CENTS) return "+ extra $50 OFF at checkout";
  return "";
}

function getCartDiscountBadgeText(badge) {
  return String(badge || "").replace(/^\+\s*/, "");
}

function fetchShopifyProductJSON(productUrl) {
  const parts = String(productUrl || "").split("/products/");
  if (parts.length < 2) {
    return Promise.reject(new Error("Invalid product URL"));
  }

  const handleAndQuery = parts[1];
  const handle = handleAndQuery.split("?")[0].split("#")[0];
  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";
  const url = `${window.location.origin}${root}products/${handle}.js`;

  return fetch(url).then(function (response) {
    if (!response.ok) throw new Error("Product fetch failed");
    return response.json();
  });
}

function enrichWishlistProductPricing(product) {
  const fallbackPriceCents = Number(product.raw_price_cents) || 0;

  return fetchShopifyProductJSON(product.du)
    .then(function (shopifyProduct) {
      const variant =
        (shopifyProduct.variants || []).find(function (item) {
          return String(item.id) === String(product.epi);
        }) || shopifyProduct.variants?.[0];

      const priceCents = Number(variant?.price) || fallbackPriceCents;
      const compareAtCents = Number(variant?.compare_at_price) || 0;
      const onSale = compareAtCents > priceCents;
      const cartDiscountBadge = getCartDiscountBadge(priceCents);

      product.formatted_price = formatWishlistMoney(priceCents);
      product.formatted_compare_at = onSale
        ? formatWishlistMoney(compareAtCents)
        : "";
      product.price_state_class = onSale ? "f-price--on-sale" : "";
      product.cart_discount_badge = cartDiscountBadge;
      product.cart_discount_badge_text = getCartDiscountBadgeText(cartDiscountBadge);
      product.cart_discount_hidden_class = cartDiscountBadge ? "" : "hidden";
      return product;
    })
    .catch(function () {
      const cartDiscountBadge = getCartDiscountBadge(fallbackPriceCents);
      product.formatted_price = formatWishlistMoney(fallbackPriceCents);
      product.formatted_compare_at = "";
      product.price_state_class = "";
      product.cart_discount_badge = cartDiscountBadge;
      product.cart_discount_badge_text = getCartDiscountBadgeText(cartDiscountBadge);
      product.cart_discount_hidden_class = cartDiscountBadge ? "" : "hidden";
      return product;
    });
}

function onAddToCartClick(e) {
  e.preventDefault();
  console.log("Add to cart clicked");
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function getWishlistSectionElements() {
  const wishlistSection = document.querySelector(".wishlist-section");
  const wishlistItemsContainer = document.getElementById(
    "wishlist-items-container"
  );
  const rootSection = wishlistSection
    ? wishlistSection.closest(".shopify-section")
    : null;

  return { wishlistSection, wishlistItemsContainer, rootSection };
}

function shouldHideWishlistWhenEmpty() {
  const { wishlistSection } = getWishlistSectionElements();
  return Boolean(
    wishlistSection && wishlistSection.hasAttribute("data-hide-when-empty")
  );
}

function setWishlistSectionVisibility(isVisible) {
  const { rootSection } = getWishlistSectionElements();
  if (!rootSection) return;
  rootSection.style.display = isVisible ? "" : "none";
}

function renderWishlistProducts() {
  var wishlistContentsContainer = document.getElementById(
    "wishlist-items-container"
  );

  const displayProducts = allProducts.slice(0, 4);

  var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
    products: displayProducts,
  });

  if (wishlistContentsContainer) {
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    wishlistContentsContainer.classList.add("horizontal-scroll-container");
    attachClickListeners();
  } else {
    console.log("Container not found, Wishlist Page element not found");
  }
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    console.log(products);

    const totalProducts = products.length;
    const { wishlistItemsContainer } = getWishlistSectionElements();

    if (totalProducts === 0) {
      if (shouldHideWishlistWhenEmpty()) {
        setWishlistSectionVisibility(false);
        return;
      }

      if (wishlistItemsContainer) {
        wishlistItemsContainer.innerHTML = `
          <div class="empty-wishlist-message" style="text-align: center; padding: 40px 0;">
            <p style="font-size: 16px; color: #777C8D; margin-bottom: 20px;">Your wishlist is currently empty.</p>
            <a href="/collections/all" class="btn" style="background-color: #161519; color: white; padding: 10px 20px; text-decoration: none; display: inline-block;">
              Continue Shopping
            </a>
          </div>
        `;
      }
      return;
    }

    setWishlistSectionVisibility(true);

    var formattedWishlistedProducts = products.map(function (p) {
      p.raw_price_cents = Number(p.pr) || 0;
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      return p;
    });

    Promise.all(
      formattedWishlistedProducts.map(function (product) {
        return enrichWishlistProductPricing(product);
      })
    ).then(function (enrichedProducts) {
      allProducts = enrichedProducts;
      renderWishlistProducts();
    });
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }

  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }

  console.log("Events attached!");
}

function changeLoginHeading() {
  const loginHeading = document.querySelector(
    ".swym-storefront-layout-login-heading"
  );
  if (loginHeading) {
    loginHeading.textContent = "Don't Lose Your Wishlist!";
    return true;
  } else {
    return false;
  }
}

function observeSwymLoginComponents() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const loginHeading = node.querySelector(
              ".swym-storefront-layout-login-heading"
            );
            if (loginHeading) {
              loginHeading.textContent = "Don't Lose Your Wishlist!";
            }

            if (
              node.classList &&
              node.classList.contains("swym-storefront-layout-login-heading")
            ) {
              node.textContent = "Don't Lose Your Wishlist!";
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function continuouslyChangeHeading() {
  let attempts = 0;
  const maxAttempts = 20;

  const interval = setInterval(function () {
    attempts++;
    const success = changeLoginHeading();

    if (success || attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 500);
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);

observeSwymLoginComponents();

continuouslyChangeHeading();

document.addEventListener("DOMContentLoaded", function () {
  changeLoginHeading();
});

setTimeout(changeLoginHeading, 1000);
setTimeout(changeLoginHeading, 2000);
setTimeout(changeLoginHeading, 5000);
setTimeout(changeLoginHeading, 10000);
